





























































































































import { Component, Vue } from "vue-property-decorator";
import TokenUtil from "@/utils/TokenUtil";
import AuthModule from "@/store/auth";
import ConversationsApi from "@/services/Conversations";
import MessagesApi from "@/services/Messages";
import ChatTemplate from "@/components/chat/ChatTemplate.vue";
import { io } from "socket.io-client";

@Component({
  components: {
    ChatTemplate,
  },
})
export default class ULoginHeader extends Vue {
  // メニューリストの表示
  private isMenuList = false;

  // チャット通知
  private notice = 0;

  // チャットテンプレート
  private isChatTemp = false;

  // プレミア会員登録ダイアログ
  private isPremierDialog = false;

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  private socket = io(
    `${process.env?.NODE_ENV === "development" ? "http://localhost:3000" : process.env.VUE_APP_SOCKET_URL}`,
    {
      withCredentials: true,
      path: `${process.env?.NODE_ENV === "development" ? "" : "/api/socket.io"}`,
    }
  );

  private async mounted() {
    this.socket.on("sendConversationUuid", () => {
      if (this.$route.name !== "UChat") {
        this.fetchNotice();
      }
    });
    if (this.$route.name !== "UChat") {
      await this.fetchNotice();
    }
  }

  // 通知の取得
  private async fetchNotice() {
    if (this.me) {
      const conversationsRes = await ConversationsApi.instance.getConversationByUserUuid(this.me.uuid);
      const conversations = conversationsRes.data.data.items;

      if (conversations.length > 0) {
        const getNewMessageCountRes = await MessagesApi.instance.getNewMessageCount(this.me.uuid, {
          conversationUuids: [conversations[0].uuid],
        });
        this.notice = getNewMessageCountRes.data.data.count;
      }
    }
  }

  // チャットクリック
  private clickChat() {
    // 一般ユーザーかつプレミア会員でない場合
    if (this.me?.roleId === 2 && !this.me?.paidFlag) {
      this.isPremierDialog = true;
    } else if (this.notice || window.innerWidth <= 640) {
      if (this.$route.name !== "UChat") {
        this.$router.push({ name: "UChat" });
      }
      this.notice = 0;
    } else {
      if (this.isMenuList) {
        this.isMenuList = false;
      }
      this.isChatTemp = !this.isChatTemp;
    }
  }

  // メニューリストを押したときのv-show切り替え
  private clickMenu() {
    if (this.isChatTemp) {
      this.isChatTemp = false;
    }
    this.isMenuList = !this.isMenuList;
  }

  // ダイアログを閉じる
  closeDialog(value: boolean) {
    this.isChatTemp = value;
  }

  // ログアウト処理
  private logout() {
    TokenUtil.removeToken();
    AuthModule.commitMe(null);
    // ログアウトと同時にトップページに戻る
    this.$router.push("/");
  }
}
